<div class="p-4">
    <mat-accordion *ngIf="(decisioning$ | async)?.length else emptyState">
        <ng-container *ngFor="let decision of (decisioning$ | async); first as isFirst" r>
            <mat-expansion-panel [expanded]="isFirst">
                <mat-expansion-panel-header>
                    <mat-panel-title class="grid grid-flow-col justify-between py-2">
                        <span class="font-semibold text-lg">{{decision.product.name}} - Preapproval</span>
                        <div class="grid grid-flow-col justify-center gap-2"
                            [ngClass]="{
                                'text-green-600': decision.preapprovalMatchPercentage == 100,
                                'text-red-500': decision.preapprovalMatchPercentage < 100
                            }"
                        >
                            <mat-icon>{{decision.preapprovalMatchPercentage < 100 ? 'cancel' : 'check_circle'}}</mat-icon>
                            <span>{{decision.preapprovalMatchPercentage < 100 ? 'Disqualified' : 'Qualified' }}</span>
                            <span>({{decision.preapprovalMatchPercentage > 0 ? decision.preapprovalMatchPercentage : 0}}%)</span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <app-qualifier-values-table
                    [qualifierValues]="decision.preapprovalQualifierValues"
                ></app-qualifier-values-table>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="grid grid-flow-col justify-between py-2">
                        <span class="font-semibold text-lg">{{decision.product.name}} - Approval</span>
                        <div class="grid grid-flow-col justify-center gap-2"
                            [ngClass]="{
                                'text-green-600': decision.approvalMatchPercentage == 100,
                                'text-red-500': decision.approvalMatchPercentage < 100
                            }"
                        >
                            <mat-icon>{{decision.approvalMatchPercentage < 100 ? 'cancel' : 'check_circle'}}</mat-icon>
                            <span>{{decision.approvalMatchPercentage < 100 ? 'Disqualified' : 'Qualified' }}</span>
                            <span>({{decision.approvalMatchPercentage}}%)</span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <app-qualifier-values-table
                    [qualifierValues]="decision.approvalQualifierValues"
                ></app-qualifier-values-table>
            </mat-expansion-panel>
        </ng-container>
    </mat-accordion>
</div>

<ng-template #emptyState>
    <mat-card class="m-4" appearance="outlined">
        <app-empty-state
            [label]="'Decisioning has not run for this business yet.'"
            [loading]="loading$ | async"
        ></app-empty-state>
    </mat-card>
</ng-template>
